import React, {useEffect, useMemo, useState} from 'react';

import { NavLink, Routes, Route } from 'react-router-dom';

import { Avatar, Layout, Dropdown, Badge,Tooltip } from 'antd';

import { UserOutlined, BellOutlined } from '@ant-design/icons';

import './App.css';

import SPMenu from './components/carRental/base/SPMenu';

import SPHeader from './components/base/SPHeader';


import SPGlobalNotification from './components/base/SPGlobalNotification';

import SPOpenBusinessModal from './components/base/SPOpenBusinessModal';

import CarRentalStoreManagementStoreRating from './pages/carRental/storeManagement/StoreRating';
import CarRentalStoreManagementRemoteReturn from './pages/carRental/storeManagement/RemoteReturn';
import CarRentalStoreManagementStoreList from './pages/carRental/storeManagement/StoreList';
import CarRentalVehicleManagementVehicle from './pages/carRental/vehicleManagement/Vehicle';
import CarRentalVehicleManagementCalendarNew from './pages/carRental/vehicleManagement/CalendarNew';
import CarRentalVehicleManagementSummary from './pages/carRental/vehicleManagement/Summary';
import CarRentalEmployeeManagementEmployeeList from './pages/carRental/employeeManagement/EmployeeList';
import CarRentalEmployeeManagementRolePermissions from './pages/carRental/employeeManagement/RolePermissions';

// todo:rebuild
import CarModelPrice from './pages/product-price/car-model-price';
import ValueAddedPrice from './pages/product-price/value-added-price';
import BookingRuleTemplate from './pages/product-price/booking-rule-template';
import ServicePolicyTemplate from './pages/product-price/service-policy-template';
import CancelRuleTemplate from './pages/product-price/cancel-rule-template';
import OrderList from './pages/order-management/order-list';
import NotificationList from './pages/notification/notificationList';
import CSOrderList from './pages/notification/csOrderList';
import SupplierEntry from './pages/supplier-entry';
import SupplierEntryHome from './pages/supplier-entry/entry-home';
import ActivityList from 'pages/marketing-activities/activity-list';
import useStore from 'store/base';
import TakeTheLead from './pages/actives/take-the-lead';
import DidiSection from './pages/actives/didi-section';

import { API_BASE_PERMISSION, API_BASE_ENUMS, API_BASE_ENCRYPT_KEY, API_BASE_USERINFO } from './api/base';

import request from './request';
import { _GLOBAL } from './consts';
import {isPhoneFn} from "./utils/tool";
import {_APIS} from "./apis";
import {jsonParseData} from "./utils";

const { Header, Content, Sider } = Layout;

function App() {
	const [isLoaded, setIsLoaded] = useState<boolean>(false);
	const [username, setUsername] = useState('');
    const [supplierName, setSupplierName] = useState('');
	const [userInfo, setUserInfo] = useState<any>({});
  const [collapsed, setCollapsed] = useState(isPhoneFn());

	const { enums, permission, fetchSecretKey, fetchEnums, fetchPermission } = useStore((state: any) => ({ ...state }));

	const loadUserInfo = () => {
		return request.get(API_BASE_USERINFO).then((res: any) => {
			setUsername(res?.data?.user_name);
			setUserInfo(res?.data)
			setSupplierName(res?.data?.supplier_name);
		});
	};

  const CollapseFn = () => {
    if (isPhoneFn()) return
    setCollapsed(!collapsed);
  }


	// 加载密钥,枚举等
	useEffect(() => {
		Promise.all([fetchSecretKey(), fetchEnums(), fetchPermission(), loadUserInfo()])
			.then(_ => {
				setIsLoaded(true);
			})
			.catch(() => {
				setIsLoaded(true);
			});
	}, []);

	return (
		<Layout>
			<SPOpenBusinessModal userInfo={userInfo} enums={enums}></SPOpenBusinessModal>
			<Header style={{
				display: 'flex', alignItems: 'center', height: '64px',
				backgroundImage: enums.f_supplier_white_list?.length == 0 ||  enums.f_supplier_white_list?.find((item:any) => item.key == userInfo?.supplier_code)?'url(https://dpubstatic.udache.com/static/dpubimg/nMNXPb6CCyhrYKvZRYyA2_openTop.png)':'',
				backgroundSize: 'cover',
				backgroundPosition: 'center',
			 }}>
                <SPHeader username={username} enums={enums} supplierName={supplierName}></SPHeader>
			</Header>
			<Layout>
				<Sider collapsedWidth={68} trigger={null} collapsible collapsed={collapsed}>
					<SPMenu collapsed={collapsed} CollapseFn={CollapseFn} permission={permission} />
				</Sider>
				{isLoaded && (
					<Content
						style={{
							padding: '20px',
							borderRadius: '4px',
							margin: '20px',
							minHeight: '100%',
							height: 'calc(100vh - 104px)',
							overflowY: 'auto',
							backgroundColor: 'white',
						}}
					>
						<SPGlobalNotification permission={permission}></SPGlobalNotification>
						<Routes>
							<Route path="/home" element={<SupplierEntryHome userInfo={userInfo} enums={enums} permission={permission} />} />
							<Route path="*" element={<SupplierEntryHome userInfo={userInfo} enums={enums} permission={permission} />} />
							<Route
								path="/storeManagement/Score"
								element={<CarRentalStoreManagementStoreRating permission={permission} enums={enums}/>}
							/>
							<Route
								path="/storeManagement/RemoteReturn"
								element={<CarRentalStoreManagementRemoteReturn permission={permission} enums={enums} />}
							/>
							<Route
								path="/storeManagement/StoreList"
								element={
									<CarRentalStoreManagementStoreList
										enums={enums}
										permission={permission}
									/>
								}
							/>
							<Route
								path="/vehicleManagement/Vehicle"
								element={
									<CarRentalVehicleManagementVehicle
										enums={enums}
										permission={permission}
									/>
								}
							/>
							<Route
								path="/vehicleManagement/calendar"
								element={
                  <CarRentalVehicleManagementCalendarNew
                    permission={permission}
                    enums={enums}/>
                }
							/>
							<Route
								path="/vehicleManagement/summary"
								element={
									<CarRentalVehicleManagementSummary
										permission={permission}
										enums={enums}
									/>
								}
							/>
							<Route
								path="/employeeManagement/EmployeeList"
								element={
									<CarRentalEmployeeManagementEmployeeList
										enums={enums}
										permission={permission}
									/>
								}
							/>
							<Route
								path="/employeeManagement/RolePermissions"
								element={
									<CarRentalEmployeeManagementRolePermissions enums={enums} permission={permission} />
								}
							/>
							<Route
								path="/product-price/car-model-price"
								element={<CarModelPrice enums={enums} permission={permission} />}
							/>
							<Route
								path="/product-price/value-added-price"
								element={
									<ValueAddedPrice enums={enums} permission={permission} />
								}
							/>
							<Route
								path="/product-price/booking-rule-template"
								element={
									<BookingRuleTemplate enums={enums} permission={permission} />
								}
							/>
							<Route
								path="/product-price/service-policy-template"
								element={
									<ServicePolicyTemplate
										enums={enums}
										permission={permission}
									/>
								}
							/>
							<Route
								path="/product-price/cancel-rule-template"
								element={
									<CancelRuleTemplate enums={enums} permission={permission} />
								}
							/>
							<Route
								path="/order-management/order-list"
								element={<OrderList enums={enums} permission={permission} />}
							/>
							<Route
								path="/notification/notificationList"
								element={
									<NotificationList enums={enums} permission={permission} />
								}
							/>
							<Route
								path="/actives/take-the-lead"
								element={
								<TakeTheLead enums={enums} permission={permission} />
								}
							/>
							<Route
								path="/actives/didi-section"
								element={
								<DidiSection enums={enums} permission={permission} />
								}
							/>
							<Route
								path="/notification/csOrderList"
								element={
									<CSOrderList enums={enums} permission={permission} />
								}
							/>
							<Route path="/supplier-entry" element={<SupplierEntry enums={enums} permission={permission} />} />
							<Route path="/actives/activity-list" element={<ActivityList />} />
						</Routes>
					</Content>
				)}
			</Layout>
		</Layout>
	);
}

export default App;
